import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import VariantButtonGroup from './VariantButtonGroup';
import ClientProvider from './client';
export default createDemo(import.meta.url, VariantButtonGroup, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/button-group/demos/variant/VariantButtonGroup.tsx",
    "fileName": "VariantButtonGroup.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Button from '@mui/material/Button';\nimport ButtonGroup from '@mui/material/ButtonGroup';\nimport Box from '@mui/material/Box';\n\nexport default function VariantButtonGroup() {\n  return (\n    <Box\n      sx={{\n        display: 'flex',\n        flexDirection: 'column',\n        alignItems: 'center',\n        '& > *': {\n          m: 1,\n        },\n      }}\n    >\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <ButtonGroup variant=\"outlined\" aria-label=\"Basic button group\">\n        <Button>One</Button>\n        <Button>Two</Button>\n        <Button>Three</Button>\n      </ButtonGroup>\n      <ButtonGroup variant=\"text\" aria-label=\"Basic button group\">\n        <Button>One</Button>\n        <Button>Two</Button>\n        <Button>Three</Button>\n      </ButtonGroup>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 29,
        "focusedLines": 10,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Button from '@mui/material/Button';\nimport ButtonGroup from '@mui/material/ButtonGroup';\nimport Box from '@mui/material/Box';\n\nexport default function VariantButtonGroup() {\n  return (\n    <Box\n      sx={{\n        display: 'flex',\n        flexDirection: 'column',\n        alignItems: 'center',\n        '& > *': {\n          m: 1,\n        },\n      }}\n    >\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <ButtonGroup variant=\"outlined\" aria-label=\"Basic button group\">\n        <Button>One</Button>\n        <Button>Two</Button>\n        <Button>Three</Button>\n      </ButtonGroup>\n      <ButtonGroup variant=\"text\" aria-label=\"Basic button group\">\n        <Button>One</Button>\n        <Button>Two</Button>\n        <Button>Three</Button>\n      </ButtonGroup>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 17
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "ButtonGroup"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "variant"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "outlined",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "aria-label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Basic button group",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 18
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Button"
              ],
              ">One</",
              [
                "span",
                "pl-c1 di-jsx",
                "Button"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 19
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Button"
              ],
              ">Two</",
              [
                "span",
                "pl-c1 di-jsx",
                "Button"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 20
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Button"
              ],
              ">Three</",
              [
                "span",
                "pl-c1 di-jsx",
                "Button"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 21
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "ButtonGroup"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 22
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "ButtonGroup"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "variant"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "text",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "aria-label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Basic button group",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 23
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Button"
              ],
              ">One</",
              [
                "span",
                "pl-c1 di-jsx",
                "Button"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 24
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Button"
              ],
              ">Two</",
              [
                "span",
                "pl-c1 di-jsx",
                "Button"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 25
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Button"
              ],
              ">Three</",
              [
                "span",
                "pl-c1 di-jsx",
                "Button"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 26
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "ButtonGroup"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 29,
    "focusedLines": 10,
    "collapsible": true,
    "externals": [
      "@mui/material/Button",
      "@mui/material/ButtonGroup",
      "@mui/material/Box"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
